import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import baseURL, { endPoints } from '../../Config';

const initialState = {
    user: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
    loading: false,
    error: null
};

const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        logout(state) {
            localStorage.removeItem('user');
            state.user = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(Userlogin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(Userlogin.fulfilled, (state, action) => {
                state.loading = false;
                state.user = action.payload;
                state.userdashboard = action.payload.data;
                localStorage.setItem('user', JSON.stringify(action.payload));
            })
            .addCase(Userlogin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const Userlogin = createAsyncThunk('auth/portal-login', async ({ navigate, formData }, { rejectWithValue }) => {
    try {
        let response = null;
        // if (isUser) {
        response = await axios.post(`${baseURL}${endPoints.login}`, formData);
        // }
        // else {
        //     response = await axios.post(`${config.baseUrl}${endPoints.customerLogin}`, formData);
        // }

        if (response.data) {
            toast.success(response?.data?.message, { autoClose: 1000 }); // Toast will disappear in 2 seconds
            navigate('/');
            // window.location.reload();
        }
        // {
        //     localStorage.setItem('isCustomer', isUser ? 'false' : 'true');
        // }

        return response.data;
    } catch (error) {
        const errorMessage = error.response && error.response.data.msg ? error.response.data.msg : error.message;
        toast.error(error.response?.data.message, { autoClose: 1000 }); // Error toast
        return rejectWithValue(errorMessage);
    }
});

export const { logout, setUser } = loginSlice.actions;

export default loginSlice.reducer;
